module.exports = __webpack_public_path__ + "img/ANNULER_DER_ACTION_GRILLE_POINTAGE_BLANC.e1028afe.svg";